module.exports = __webpack_public_path__ + "static/contact-kv-68438fd0b0c6fea823bdfbac221adbb4.jpg";